import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAccount } from '../../../shared/models/api/user';
import { PasswordUpdateResponse, UserAccountApiService } from '../../repos/user-account/user-account.service';


@Injectable({
  providedIn: 'root'
})
export class UserAccountService {
  apiService = inject(UserAccountApiService);

  getAccount(): Observable<UserAccount> {
    return this.apiService.getAccount();
  }

  updateMyPassword({
    password,
    confirmPassword,
    identityPlatformId,
  }: {
    password: string,
    confirmPassword: string,
    identityPlatformId: string,
  }): Observable<PasswordUpdateResponse> {
    return this.apiService.updateMyPassword({
      password,
      confirmPassword,
      identityPlatformId,
    });
  }
}
